var React = require('react');

function ExpandInline (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0)","key":0},React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M6 8V14H8V8H14V6H8V0H6V6H0V8H6Z"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0"},React.createElement("rect",{"width":"14","height":"14"})))]);
}

ExpandInline.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none"};

module.exports = ExpandInline;

ExpandInline.default = ExpandInline;
